import logo from "./logo.svg";
import "./App.css";
import Hero from "./Components/Hero-section";
import Header from "./Components/Header";
import Navbar from "./Components/Navbar";
import Aboutus from "./Components/Aboutus";
import Footer from "./Components/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Aboutus />
      <Footer />
      {/* <Hero /> */}
    </div>
  );
}

export default App;
